import React, { useMemo } from 'react'
import { ROUTES } from 'constants/routes'
import { Trans, useTranslation } from 'react-i18next'
import { Grid, Icon, Typography } from 'gu-ui-kit'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import clsx from 'clsx'

const EmptyWalletNotification = ({ activeMethod, wallet, className }) => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()

  const wallets = useMemo(() => activeMethod?.params?.wallets ?? null, [activeMethod])

  const showNotification = useMemo(() => {
    if (activeMethod?.method !== 'user_balance') {
      return false
    }

    if (wallets.length === 0) {
      return true
    }

    return wallet?.balance !== undefined && wallet.balance === 0
  }, [wallets, activeMethod, wallet])

  return (
    showNotification && (
      <Grid
        className={clsx(
          styles['billing__notification'],
          styles['billing__notification_notice'],
          className,
        )}
        direction={'row'}
        wrap={false}
        gap={16}
      >
        <Icon
          size={'m'}
          name={'status warning'}
          color={'Accent-Notice-Secondary'}
        />
        <Grid
          direction={'column'}
          gap={4}
        >
          <Typography variant={'Subtitle-20'}>
            {t('billing::form.wallet_id.notifications.empty_wallet.title')}
          </Typography>
          <div>
            <Typography
              component={'span'}
              variant={'Body-20'}
            >
              <Trans i18nKey={'billing::form.wallet_id.notifications.empty_wallet.description'}>
                Для пополнения рекламного аккаунта с помощью баланса getUNIQ необходимо
                <Link to={pathGen(ROUTES.BILLING_TOP_UP)}>пополнить баланс</Link>
              </Trans>
            </Typography>
          </div>
        </Grid>
      </Grid>
    )
  )
}

export default EmptyWalletNotification

EmptyWalletNotification.propTypes = {
  activeMethod: PropTypes.object,
  className: PropTypes.string,
  wallet: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
}
